import { Component, OnInit } from '@angular/core';
declare var $:any;
@Component({
  selector: 'app-alumni',
  templateUrl: './alumni.component.html',
  styleUrls: ['./alumni.component.scss']
})
export class AlumniComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    $('.carousel').carousel({
      pause: false,
      interval:3000
    })
  }

}
